import {AfterContentChecked, ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {SpinnerService} from './spinner.service';
import {Subscription} from 'rxjs';
import {delay, timeout} from 'rxjs/operators';

@Component({
    selector: 'app-spinner',
    templateUrl: 'spinner-load.component.html',
    styleUrls: ['./spinner-load.component.css']
})
export class SpinnerLoadComponent implements OnInit, OnDestroy {

  public isSpinnerVisible = false;
  private subscription: Subscription;

  constructor(private service: SpinnerService,
              private cd: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.subscription = this.service.isSpinnerVisible
      .subscribe(res => {
        this.isSpinnerVisible = !!res;
        this.cd.detectChanges();
      });
  }


  ngOnDestroy(): void {
    this.isSpinnerVisible = false;
    this.subscription.unsubscribe();
  }
}
